// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Custom Properties for Brand Colors */
:root {
  --primary-blue: #0055FF;
  --cta-orange: #FF6A00;
  --highlight-cyan: #00FFFF;
  --text-gray: #222831;
  --bg-soft-blue: #F4F7FA;
  --white: #ffffff;
  --light-gray: #f8f9fa;
  --dark-gray: #666;
  
  /* Typography */
  --font-heading: 'Inter', sans-serif;
  --font-body: 'Roboto', sans-serif;
  
  /* Spacing */
  --spacing-xs: 0.5rem;
  --spacing-sm: 1rem;
  --spacing-md: 1.5rem;
  --spacing-lg: 2rem;
  --spacing-xl: 3rem;
  --spacing-xxl: 4rem;
  
  /* Breakpoints */
  --mobile: 768px;
  --tablet: 1024px;
  --desktop: 1200px;
}

/* Reset and Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: var(--font-body);
  color: var(--text-gray);
  line-height: 1.6;
  background-color: var(--white);
}

.container {
  max-width: var(--desktop);
  margin: 0 auto;
  padding: 0 var(--spacing-md);
}

/* Typography */
h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-heading);
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: var(--spacing-sm);
}

h1 {
  font-size: 3rem;
  font-weight: 700;
}

h2 {
  font-size: 2.5rem;
}

h3 {
  font-size: 1.5rem;
}

p {
  margin-bottom: var(--spacing-sm);
}

/* Buttons */
.btn-primary, .btn-secondary, .btn-login {
  padding: var(--spacing-sm) var(--spacing-lg);
  border: none;
  border-radius: 8px;
  font-family: var(--font-heading);
  font-weight: 500;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
  text-align: center;
}

.btn-primary {
  background-color: var(--cta-orange);
  color: var(--white);
}

.btn-primary:hover {
  background-color: #e55a00;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 106, 0, 0.3);
}

.btn-secondary {
  background-color: transparent;
  color: var(--primary-blue);
  border: 2px solid var(--primary-blue);
}

.btn-secondary:hover {
  background-color: var(--primary-blue);
  color: var(--white);
  transform: translateY(-2px);
}

.btn-login {
  background-color: var(--primary-blue);
  color: var(--white);
  padding: var(--spacing-xs) var(--spacing-md);
}

.btn-login:hover {
  background-color: #0044cc;
}

/* Navigation */
.navbar {
  background-color: var(--white);
  padding: var(--spacing-sm) 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.nav-container {
  max-width: var(--desktop);
  margin: 0 auto;
  padding: 0 var(--spacing-md);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-logo h2 {
  color: var(--primary-blue);
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
}

.nav-menu {
  display: flex;
  list-style: none;
  align-items: center;
  gap: var(--spacing-lg);
}

.nav-link {
  text-decoration: none;
  color: var(--text-gray);
  font-weight: 500;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: var(--primary-blue);
}

.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
}

.bar {
  width: 25px;
  height: 3px;
  background-color: var(--text-gray);
  margin: 3px 0;
  transition: 0.3s;
}

/* Hero Section */
.hero {
  background: linear-gradient(135deg, var(--bg-soft-blue) 0%, var(--white) 100%);
  padding: calc(80px + var(--spacing-xxl)) 0 var(--spacing-xxl) 0;
  margin-top: 0;
}

.hero-container {
  max-width: var(--desktop);
  margin: 0 auto;
  padding: 0 var(--spacing-md);
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-xl);
  align-items: center;
}

.hero-title {
  background: linear-gradient(135deg, var(--primary-blue), var(--highlight-cyan));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: var(--spacing-md);
}

.hero-subtitle {
  font-size: 1.2rem;
  color: var(--dark-gray);
  margin-bottom: var(--spacing-lg);
}

.hero-buttons {
  display: flex;
  gap: var(--spacing-md);
  flex-wrap: wrap;
}

.hero-image {
  width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

/* Section Headers */
.section-header {
  text-align: center;
  margin-bottom: var(--spacing-xl);
}

.section-header h2 {
  color: var(--text-gray);
  margin-bottom: var(--spacing-sm);
}

.section-header p {
  font-size: 1.1rem;
  color: var(--dark-gray);
}

/* Features Section */
.features {
  padding: var(--spacing-xxl) 0;
  background-color: var(--white);
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--spacing-xl);
}

.feature-card {
  text-align: center;
  padding: var(--spacing-xl);
  background-color: var(--light-gray);
  border-radius: 12px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 85, 255, 0.1);
}

.feature-icon img {
  width: 80px;
  height: 80px;
  margin-bottom: var(--spacing-md);
}

.feature-card h3 {
  color: var(--primary-blue);
  margin-bottom: var(--spacing-sm);
}

/* How It Works Section */
.how-it-works {
  padding: var(--spacing-xxl) 0;
  background-color: var(--bg-soft-blue);
}

.process-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--spacing-xl);
  margin-bottom: var(--spacing-xl);
}

.process-step {
  text-align: center;
  padding: var(--spacing-lg);
}

.step-number {
  width: 60px;
  height: 60px;
  background-color: var(--cta-orange);
  color: var(--white);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 auto var(--spacing-md) auto;
}

.process-image {
  width: 100%;
  max-width: 600px;
  height: auto;
  margin: 0 auto;
  display: block;
  border-radius: 12px;
}

/* Use Cases Section */
.use-cases {
  padding: var(--spacing-xxl) 0;
  background-color: var(--white);
}

.use-cases-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--spacing-lg);
}

.use-case-card {
  padding: var(--spacing-lg);
  background-color: var(--light-gray);
  border-radius: 12px;
  border-left: 4px solid var(--primary-blue);
  transition: transform 0.3s ease;
}

.use-case-card:hover {
  transform: translateY(-3px);
}

.use-case-card h3 {
  color: var(--primary-blue);
  margin-bottom: var(--spacing-sm);
}

/* AI Features Section */
.ai-features {
  padding: var(--spacing-xxl) 0;
  background-color: var(--bg-soft-blue);
}

.ai-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-xl);
  align-items: center;
}

.ai-benefits {
  list-style: none;
  margin-top: var(--spacing-md);
}

.ai-benefits li {
  padding: var(--spacing-xs) 0;
  position: relative;
  padding-left: var(--spacing-md);
}

.ai-benefits li::before {
  content: "✓";
  color: var(--highlight-cyan);
  font-weight: bold;
  position: absolute;
  left: 0;
}

.ai-image {
  width: 100%;
  height: auto;
  border-radius: 12px;
}

/* Contact Section */
.contact {
  padding: var(--spacing-xxl) 0;
  background-color: var(--white);
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-xl);
  align-items: center;
}

.contact-buttons {
  display: flex;
  gap: var(--spacing-md);
  flex-wrap: wrap;
  margin-top: var(--spacing-lg);
}

.contact-image {
  width: 100%;
  height: auto;
  border-radius: 12px;
}

/* Footer */
.footer {
  background-color: var(--text-gray);
  color: var(--white);
  padding: var(--spacing-xl) 0 var(--spacing-md) 0;
}

.footer-content {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: var(--spacing-xl);
  margin-bottom: var(--spacing-lg);
}

.footer-brand h3 {
  color: var(--highlight-cyan);
  margin-bottom: var(--spacing-sm);
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: var(--spacing-lg);
}

.footer-column h4 {
  color: var(--white);
  margin-bottom: var(--spacing-sm);
}

.footer-column ul {
  list-style: none;
}

.footer-column a {
  color: #ccc;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-column a:hover {
  color: var(--highlight-cyan);
}

.footer-bottom {
  border-top: 1px solid #444;
  padding-top: var(--spacing-md);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.version {
  color: var(--highlight-cyan);
  font-weight: 500;
}

/* Modal Styles */
.modal {
  display: none;
  position: fixed;
  z-index: 2000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  animation: fadeIn 0.3s ease;
}

.modal-content {
  background-color: var(--white);
  margin: 10% auto;
  padding: var(--spacing-xl);
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  position: relative;
  animation: slideIn 0.3s ease;
}

.close {
  color: var(--dark-gray);
  float: right;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
  position: absolute;
  right: var(--spacing-md);
  top: var(--spacing-md);
}

.close:hover {
  color: var(--text-gray);
}

.form-group {
  margin-bottom: var(--spacing-md);
}

.form-group label {
  display: block;
  margin-bottom: var(--spacing-xs);
  font-weight: 500;
  color: var(--text-gray);
}

.form-group input {
  width: 100%;
  padding: var(--spacing-sm);
  border: 2px solid #ddd;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

.form-group input:focus {
  outline: none;
  border-color: var(--primary-blue);
}

.form-footer {
  text-align: center;
  margin-top: var(--spacing-md);
}

.form-footer a {
  color: var(--primary-blue);
  text-decoration: none;
}

.form-footer a:hover {
  text-decoration: underline;
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from { transform: translateY(-50px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* Responsive Design */
@media (max-width: 1024px) {
  .hero-container,
  .ai-content,
  .contact-content {
    grid-template-columns: 1fr;
    text-align: center;
  }
  
  .hero-buttons {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .hamburger {
    display: flex;
  }
  
  .nav-menu {
    position: fixed;
    left: -100%;
    top: 70px;
    flex-direction: column;
    background-color: var(--white);
    width: 100%;
    text-align: center;
    transition: 0.3s;
    box-shadow: 0 10px 27px rgba(0, 0, 0, 0.05);
    padding: var(--spacing-md) 0;
  }
  
  .nav-menu.active {
    left: 0;
  }
  
  h1 {
    font-size: 2rem;
  }
  
  h2 {
    font-size: 1.8rem;
  }
  
  .hero {
    padding: calc(80px + var(--spacing-lg)) 0 var(--spacing-lg) 0;
  }
  
  .hero-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .btn-primary,
  .btn-secondary {
    width: 100%;
    max-width: 250px;
  }
  
  .features-grid,
  .use-cases-grid {
    grid-template-columns: 1fr;
  }
  
  .process-grid {
    grid-template-columns: 1fr;
  }
  
  .contact-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .footer-content {
    grid-template-columns: 1fr;
    text-align: center;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: var(--spacing-sm);
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;;EAEjB,eAAe;EACf,mCAAmC;EACnC,iCAAiC;;EAEjC,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;;EAEnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,YAAY;AACZ;EACE,4CAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;EACf,MAAM;EACN,WAAW;EACX,aAAa;EACb,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,4BAA4B;EAC5B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kCAAkC;EAClC,aAAa;EACb,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,8EAA8E;EAC9E,+DAA+D;EAC/D,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,4BAA4B;EAC5B,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;EAC/E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mCAAmC;EACnC,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,mBAAmB;EACnB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA,sBAAsB;AACtB;EACE;;;IAGE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;IACX,SAAS;IACT,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,2CAA2C;IAC3C,4BAA4B;EAC9B;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;EACpB;AACF","sourcesContent":["/* CSS Custom Properties for Brand Colors */\n:root {\n  --primary-blue: #0055FF;\n  --cta-orange: #FF6A00;\n  --highlight-cyan: #00FFFF;\n  --text-gray: #222831;\n  --bg-soft-blue: #F4F7FA;\n  --white: #ffffff;\n  --light-gray: #f8f9fa;\n  --dark-gray: #666;\n  \n  /* Typography */\n  --font-heading: 'Inter', sans-serif;\n  --font-body: 'Roboto', sans-serif;\n  \n  /* Spacing */\n  --spacing-xs: 0.5rem;\n  --spacing-sm: 1rem;\n  --spacing-md: 1.5rem;\n  --spacing-lg: 2rem;\n  --spacing-xl: 3rem;\n  --spacing-xxl: 4rem;\n  \n  /* Breakpoints */\n  --mobile: 768px;\n  --tablet: 1024px;\n  --desktop: 1200px;\n}\n\n/* Reset and Base Styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: var(--font-body);\n  color: var(--text-gray);\n  line-height: 1.6;\n  background-color: var(--white);\n}\n\n.container {\n  max-width: var(--desktop);\n  margin: 0 auto;\n  padding: 0 var(--spacing-md);\n}\n\n/* Typography */\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  line-height: 1.2;\n  margin-bottom: var(--spacing-sm);\n}\n\nh1 {\n  font-size: 3rem;\n  font-weight: 700;\n}\n\nh2 {\n  font-size: 2.5rem;\n}\n\nh3 {\n  font-size: 1.5rem;\n}\n\np {\n  margin-bottom: var(--spacing-sm);\n}\n\n/* Buttons */\n.btn-primary, .btn-secondary, .btn-login {\n  padding: var(--spacing-sm) var(--spacing-lg);\n  border: none;\n  border-radius: 8px;\n  font-family: var(--font-heading);\n  font-weight: 500;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: inline-block;\n  text-align: center;\n}\n\n.btn-primary {\n  background-color: var(--cta-orange);\n  color: var(--white);\n}\n\n.btn-primary:hover {\n  background-color: #e55a00;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(255, 106, 0, 0.3);\n}\n\n.btn-secondary {\n  background-color: transparent;\n  color: var(--primary-blue);\n  border: 2px solid var(--primary-blue);\n}\n\n.btn-secondary:hover {\n  background-color: var(--primary-blue);\n  color: var(--white);\n  transform: translateY(-2px);\n}\n\n.btn-login {\n  background-color: var(--primary-blue);\n  color: var(--white);\n  padding: var(--spacing-xs) var(--spacing-md);\n}\n\n.btn-login:hover {\n  background-color: #0044cc;\n}\n\n/* Navigation */\n.navbar {\n  background-color: var(--white);\n  padding: var(--spacing-sm) 0;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 1000;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.nav-container {\n  max-width: var(--desktop);\n  margin: 0 auto;\n  padding: 0 var(--spacing-md);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.nav-logo h2 {\n  color: var(--primary-blue);\n  margin: 0;\n  font-size: 1.8rem;\n  font-weight: 700;\n}\n\n.nav-menu {\n  display: flex;\n  list-style: none;\n  align-items: center;\n  gap: var(--spacing-lg);\n}\n\n.nav-link {\n  text-decoration: none;\n  color: var(--text-gray);\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.nav-link:hover {\n  color: var(--primary-blue);\n}\n\n.hamburger {\n  display: none;\n  flex-direction: column;\n  cursor: pointer;\n}\n\n.bar {\n  width: 25px;\n  height: 3px;\n  background-color: var(--text-gray);\n  margin: 3px 0;\n  transition: 0.3s;\n}\n\n/* Hero Section */\n.hero {\n  background: linear-gradient(135deg, var(--bg-soft-blue) 0%, var(--white) 100%);\n  padding: calc(80px + var(--spacing-xxl)) 0 var(--spacing-xxl) 0;\n  margin-top: 0;\n}\n\n.hero-container {\n  max-width: var(--desktop);\n  margin: 0 auto;\n  padding: 0 var(--spacing-md);\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-xl);\n  align-items: center;\n}\n\n.hero-title {\n  background: linear-gradient(135deg, var(--primary-blue), var(--highlight-cyan));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: var(--spacing-md);\n}\n\n.hero-subtitle {\n  font-size: 1.2rem;\n  color: var(--dark-gray);\n  margin-bottom: var(--spacing-lg);\n}\n\n.hero-buttons {\n  display: flex;\n  gap: var(--spacing-md);\n  flex-wrap: wrap;\n}\n\n.hero-image {\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\n/* Section Headers */\n.section-header {\n  text-align: center;\n  margin-bottom: var(--spacing-xl);\n}\n\n.section-header h2 {\n  color: var(--text-gray);\n  margin-bottom: var(--spacing-sm);\n}\n\n.section-header p {\n  font-size: 1.1rem;\n  color: var(--dark-gray);\n}\n\n/* Features Section */\n.features {\n  padding: var(--spacing-xxl) 0;\n  background-color: var(--white);\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: var(--spacing-xl);\n}\n\n.feature-card {\n  text-align: center;\n  padding: var(--spacing-xl);\n  background-color: var(--light-gray);\n  border-radius: 12px;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.feature-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 30px rgba(0, 85, 255, 0.1);\n}\n\n.feature-icon img {\n  width: 80px;\n  height: 80px;\n  margin-bottom: var(--spacing-md);\n}\n\n.feature-card h3 {\n  color: var(--primary-blue);\n  margin-bottom: var(--spacing-sm);\n}\n\n/* How It Works Section */\n.how-it-works {\n  padding: var(--spacing-xxl) 0;\n  background-color: var(--bg-soft-blue);\n}\n\n.process-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: var(--spacing-xl);\n  margin-bottom: var(--spacing-xl);\n}\n\n.process-step {\n  text-align: center;\n  padding: var(--spacing-lg);\n}\n\n.step-number {\n  width: 60px;\n  height: 60px;\n  background-color: var(--cta-orange);\n  color: var(--white);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0 auto var(--spacing-md) auto;\n}\n\n.process-image {\n  width: 100%;\n  max-width: 600px;\n  height: auto;\n  margin: 0 auto;\n  display: block;\n  border-radius: 12px;\n}\n\n/* Use Cases Section */\n.use-cases {\n  padding: var(--spacing-xxl) 0;\n  background-color: var(--white);\n}\n\n.use-cases-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: var(--spacing-lg);\n}\n\n.use-case-card {\n  padding: var(--spacing-lg);\n  background-color: var(--light-gray);\n  border-radius: 12px;\n  border-left: 4px solid var(--primary-blue);\n  transition: transform 0.3s ease;\n}\n\n.use-case-card:hover {\n  transform: translateY(-3px);\n}\n\n.use-case-card h3 {\n  color: var(--primary-blue);\n  margin-bottom: var(--spacing-sm);\n}\n\n/* AI Features Section */\n.ai-features {\n  padding: var(--spacing-xxl) 0;\n  background-color: var(--bg-soft-blue);\n}\n\n.ai-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-xl);\n  align-items: center;\n}\n\n.ai-benefits {\n  list-style: none;\n  margin-top: var(--spacing-md);\n}\n\n.ai-benefits li {\n  padding: var(--spacing-xs) 0;\n  position: relative;\n  padding-left: var(--spacing-md);\n}\n\n.ai-benefits li::before {\n  content: \"✓\";\n  color: var(--highlight-cyan);\n  font-weight: bold;\n  position: absolute;\n  left: 0;\n}\n\n.ai-image {\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n}\n\n/* Contact Section */\n.contact {\n  padding: var(--spacing-xxl) 0;\n  background-color: var(--white);\n}\n\n.contact-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-xl);\n  align-items: center;\n}\n\n.contact-buttons {\n  display: flex;\n  gap: var(--spacing-md);\n  flex-wrap: wrap;\n  margin-top: var(--spacing-lg);\n}\n\n.contact-image {\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n}\n\n/* Footer */\n.footer {\n  background-color: var(--text-gray);\n  color: var(--white);\n  padding: var(--spacing-xl) 0 var(--spacing-md) 0;\n}\n\n.footer-content {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: var(--spacing-xl);\n  margin-bottom: var(--spacing-lg);\n}\n\n.footer-brand h3 {\n  color: var(--highlight-cyan);\n  margin-bottom: var(--spacing-sm);\n}\n\n.footer-links {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: var(--spacing-lg);\n}\n\n.footer-column h4 {\n  color: var(--white);\n  margin-bottom: var(--spacing-sm);\n}\n\n.footer-column ul {\n  list-style: none;\n}\n\n.footer-column a {\n  color: #ccc;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.footer-column a:hover {\n  color: var(--highlight-cyan);\n}\n\n.footer-bottom {\n  border-top: 1px solid #444;\n  padding-top: var(--spacing-md);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.version {\n  color: var(--highlight-cyan);\n  font-weight: 500;\n}\n\n/* Modal Styles */\n.modal {\n  display: none;\n  position: fixed;\n  z-index: 2000;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  animation: fadeIn 0.3s ease;\n}\n\n.modal-content {\n  background-color: var(--white);\n  margin: 10% auto;\n  padding: var(--spacing-xl);\n  border-radius: 12px;\n  width: 90%;\n  max-width: 400px;\n  position: relative;\n  animation: slideIn 0.3s ease;\n}\n\n.close {\n  color: var(--dark-gray);\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n  cursor: pointer;\n  position: absolute;\n  right: var(--spacing-md);\n  top: var(--spacing-md);\n}\n\n.close:hover {\n  color: var(--text-gray);\n}\n\n.form-group {\n  margin-bottom: var(--spacing-md);\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: var(--spacing-xs);\n  font-weight: 500;\n  color: var(--text-gray);\n}\n\n.form-group input {\n  width: 100%;\n  padding: var(--spacing-sm);\n  border: 2px solid #ddd;\n  border-radius: 6px;\n  font-size: 1rem;\n  transition: border-color 0.3s ease;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: var(--primary-blue);\n}\n\n.form-footer {\n  text-align: center;\n  margin-top: var(--spacing-md);\n}\n\n.form-footer a {\n  color: var(--primary-blue);\n  text-decoration: none;\n}\n\n.form-footer a:hover {\n  text-decoration: underline;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-50px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .hero-container,\n  .ai-content,\n  .contact-content {\n    grid-template-columns: 1fr;\n    text-align: center;\n  }\n  \n  .hero-buttons {\n    justify-content: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .hamburger {\n    display: flex;\n  }\n  \n  .nav-menu {\n    position: fixed;\n    left: -100%;\n    top: 70px;\n    flex-direction: column;\n    background-color: var(--white);\n    width: 100%;\n    text-align: center;\n    transition: 0.3s;\n    box-shadow: 0 10px 27px rgba(0, 0, 0, 0.05);\n    padding: var(--spacing-md) 0;\n  }\n  \n  .nav-menu.active {\n    left: 0;\n  }\n  \n  h1 {\n    font-size: 2rem;\n  }\n  \n  h2 {\n    font-size: 1.8rem;\n  }\n  \n  .hero {\n    padding: calc(80px + var(--spacing-lg)) 0 var(--spacing-lg) 0;\n  }\n  \n  .hero-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .btn-primary,\n  .btn-secondary {\n    width: 100%;\n    max-width: 250px;\n  }\n  \n  .features-grid,\n  .use-cases-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .process-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .contact-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .footer-content {\n    grid-template-columns: 1fr;\n    text-align: center;\n  }\n  \n  .footer-bottom {\n    flex-direction: column;\n    gap: var(--spacing-sm);\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
